import './index.css';
import React from 'react';
import { Routes, Route, HashRouter } from "react-router-dom";
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Services from './pages/Services/Services';
import Products from './pages/Products/Products';
import Contact from './pages/Contact/Contact';
import Blogs from './pages/Blogs/Blogs';
import MockExamList from "./features/exams/MockExamList";
import TrialPage from "./features/questions-display/TrialPage";
import UPIPayment from "./features/payments/UPIPayment";
import Dashboard from './components/dashboards/Dashboard';
import FullExamDisplay from "./features/questions-display/FullExamDisplay";

export default function App() {
  React.useEffect(() => {
    const hasSavedToken = localStorage.getItem("token");
    const hasActiveSession = sessionStorage.getItem("activeSession");

    if (hasSavedToken && !hasActiveSession) {
      localStorage.clear();
      sessionStorage.clear();
    }
  }, []);

  return (
    <HashRouter>
      <div className="app-container">
        <Header />
        <div className="app-body">
          <main className="main-content">
            <Routes>
              <Route path="/" element={<About />} />
              <Route path="/Services" element={<Services />} />
              <Route path="/Products" element={<Products />} />
              <Route path="/MockExamList" element={<MockExamList />} />
              <Route path="/trialPage" element={<TrialPage />} />
              <Route path="/pay" element={<UPIPayment />} />
              <Route path="/Contact" element={<Contact />} />
              <Route path="/Blogs" element={<Blogs />} />
              <Route path="/Dashboard" element={<Dashboard />} />
              <Route path="/UPIPayment" element={<UPIPayment />} />
              <Route path="/FullExamDisplay" element={<FullExamDisplay />} />
              <Route path="/handleCertificate" element={<FullExamDisplay />} />
              <Route path="/Home" element={<Home />} />
              <Route path="*" element={<About />} />
            </Routes></main>
        </div>
        <Footer />
      </div>
    </HashRouter>
  );
}
